import { useQuery } from "@apollo/client/react";
import { GET_REVIEWS, GetReviewsQuery } from "./shared";

export function useReviews(appId: number) {
  const { data, loading, error } = useQuery<GetReviewsQuery>(GET_REVIEWS, {
    variables: { appId },
  });

  return { data, loading, error };
}
